var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 24,
    fill: "url(#pattern0_6014_8603)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_6014_8603",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_6014_8603",
    transform: "matrix(0.0104167 0 0 0.00868056 0 0.0833333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_6014_8603",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAADV0lEQVR4nO2cv2oVQRTGP8FCCxUiJjuTQOCSO3MNNoI2FloYH0DFzkafQJ9ASyt9AP88gRY24t0TSSMW+gBRWwkoaKexELIyKYMY3cxkvpk9PzjlvXfmfHv23uW3ewFFURRFURRFURQixJu74m23x7qXex9Dbn6nIeRvfqch5G9+V00ICZvT1VAagNcAsh+FohOQvxGip6D8zZAMpd8BXgPIfhSKTkD+RkitpyBFURRFURRFUZRA68393BdAss8V9kyTvrj524MLwJlbYEF8c3VwAUyaK2BBXHN2cAH45gxYWD01O5e7IbLPNR3NzYKFDjjQerM5nKPf/Ax7BhPizMfBBODMB7Ah3qwOaAIEbIgzT2JsDrt9TuLX/+MEPEatd7ShiADsHbAh3t4cTADe3gAbMrYrgwnA2YtgQybWDSaAk/NjsLG2uHio9Xar9gBab7feLCwcBiPi7ZfqA3D2M1gRZ99VH4C3b8GKOPus+gCcfQpWxNsH1QfgiURMCjED9gCYREwKMQP2AJhETAoxA/YAmERMCjED8gCoREwKMQPiAChFTGwxA+YAGEVMbDED7gngEzGxxQy4J4BPxMQWM6AOgFDExBYzoD4FEYqY2GIG3BPAJ2JiixkwB8AoYmKLGZAGQC1iYooZsAbALGJiihnwTgCviIkpZsA7AbwiJqaYAe0EEIuYmGIGtBNALGJiihmwBsAsYmKKGdCegohFTEwxA9IAqEVMTDEDwgCKEDGxxAwYAyhBxMQSM+CcAH4RE0vMgHMC+EVMLDEDygAKEDGxxMxrf/xIqgBkNDrWZ01hLyiNvmJmOjaXkwXQ9wJxbFdQGn3FTOvM+5fLCzOxAwjv2fuWmYl1KI0gL/qKmdabT62fv/ZiaeboXgMI77F95PdsflEiJsUTM5K5ihIxKZ6YkdwBlCRiUjwxI7kDKEnEpHhiRnIHUJKI2UmQGOVPgClHxOxkdWIulR+A5b8Z629XnkX/kZOzP/70U7goWm8fZW+k710PUTpryycaceYbQTO7/6nWma/B7KEGXnl7Tpz9XkzzvdmcjpvzqAlZsqfF2/XczZXdaz2sFTWydgEHp665Ls48F2c2Wmd/5W749hqc2QhrCmsLa8zdJ0VRFEVRFEVRUDW/Abk2fiLHIio2AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrash);
export default __webpack_public_path__ + "static/media/icon_trash_.747a22995b025e336f82668fa1ca1373.svg";
export { ForwardRef as ReactComponent };